.paws {
  position: relative;
  width: 172px;
  height: 58px;
}

.paws span {
  position: absolute;
  width: 24px;
  height: 24px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-12 -12 24 24'%3E%3Cg fill='%23d9a184'%3E%3Cellipse cx='0' cy='3' rx='5.2' ry='4.4'/%3E%3Cellipse cx='-6.4' cy='-3' rx='2' ry='2.5'/%3E%3Cellipse cx='-2.3' cy='-6.6' rx='2' ry='2.5'/%3E%3Cellipse cx='2.3' cy='-6.6' rx='2' ry='2.5'/%3E%3Cellipse cx='6.4' cy='-3' rx='2' ry='2.5'/%3E%3C/g%3E%3C/svg%3E")
    center / contain no-repeat;
  rotate: 90deg;
  opacity: 0;
  animation: paw-step 2.4s infinite;
  will-change: opacity, scale;
}

.paws span:nth-child(odd) {
  top: 32px;
}

.paws span:nth-child(even) {
  top: 4px;
}

.paws span:nth-child(1) {
  left: 0;
}

.paws span:nth-child(2) {
  left: 28px;
  animation-delay: 0.3s;
}

.paws span:nth-child(3) {
  left: 56px;
  animation-delay: 0.6s;
}

.paws span:nth-child(4) {
  left: 84px;
  animation-delay: 0.9s;
}

.paws span:nth-child(5) {
  left: 112px;
  animation-delay: 1.2s;
}

.paws span:nth-child(6) {
  left: 140px;
  animation-delay: 1.5s;
}

@keyframes paw-step {
  0% {
    opacity: 0;
    scale: 0.5;
  }
  6% {
    opacity: 1;
    scale: 1.15;
  }
  10% {
    scale: 1;
  }
  55% {
    opacity: 1;
  }
  75%,
  100% {
    opacity: 0;
    scale: 1;
  }
}
